
(function () {
  'use strict';
  var STORE = '';
  var LANDING_PATH = '/pages/newsletter-hindi';
  var PRODUCT_PATH = '/pages/morning-milk-hindi';
  var VARIANTS = {
    d10: { raw: '49917590798619', pas: '49917590831387', qty: 2, name: '10 दिन', now: '₹950', mrp: '₹990', save: 'बचत ₹40', value: 950 },
    d15: { raw: '45476509483291', pas: '45588393787675', qty: 1, name: '15 दिन', now: '₹1,425', mrp: '₹1,485', save: 'बचत ₹60', value: 1425 },
    d30: { raw: '45476509483291', pas: '45588393787675', qty: 2, name: '30 दिन', now: '₹2,850', mrp: '₹2,970', save: 'बचत ₹120', value: 2850 }
  };
  var plan = 'd30', milkType = 'raw', busy = false;

  function byId(id) { return document.getElementById(id); }
  function track(name, data) {
    if (window.fbq) window.fbq('track', name, data || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({event: name}, data || {}));
  }
  function money(v) { return (v || 0).toLocaleString('en-IN', {style:'currency', currency:'INR', maximumFractionDigits:0}); }

  function showView(which, updateUrl) {
    var landing = byId('landing-view'), product = byId('product-view');
    if (!landing || !product) return;
    var isProduct = which === 'product';
    landing.hidden = isProduct;
    product.hidden = !isProduct;
    document.title = isProduct
      ? 'देसी A2 गाय का दूध | अपनी सुबह चुनें | Humpy Farms'
      : 'Humpy Farms | सुबह का शुद्ध A2 दूध';
    if (updateUrl) {
      var path = isProduct ? PRODUCT_PATH : LANDING_PATH;
      if (location.pathname !== path) history.pushState({humpyView: which}, '', path);
    }
    window.scrollTo({top:0, behavior:'auto'});
    if (isProduct) {
      paint();
      track('ViewContent', {content_name:'A2 Desi Cow Milk Glass Bottle', currency:'INR'});
    } else {
      track('ViewContent', {content_name:'Humpy Morning Milk', currency:'INR'});
    }
    var pop = byId('popcta');
    if (pop) pop.classList.remove('on');
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-plink]');
    if (cta) {
      e.preventDefault();
      showView('product', true);
      return;
    }
    var back = e.target.closest('[data-blink]');
    if (back) {
      e.preventDefault();
      showView('landing', true);
      return;
    }
  });

  window.addEventListener('popstate', function () {
    showView(location.pathname.replace(/\/+$/, '') === PRODUCT_PATH ? 'product' : 'landing', false);
  });

  window.setPlan = function (p) { if (VARIANTS[p]) { plan = p; paint(); } };
  window.setType = function (t) { if (t === 'raw' || t === 'pas') { milkType = t; paint(); } };

  function paint() {
    var v = VARIANTS[plan];
    var set = function (id, text) { var el = byId(id); if (el) el.textContent = text; };
    set('pnow', v.now); set('pmrp', v.mrp); set('psave', v.save);
    set('t-plan', v.name + ' · हर सुबह एक बोतल');
    set('t-mrp', v.mrp); set('t-now', v.now);
    var sticky = byId('s-t');
    if (sticky) sticky.innerHTML = v.name + ' · पूरा महीना<b>' + v.now + ' · ₹95 प्रति सुबह</b>';
    document.querySelectorAll('#product-view .plan').forEach(function (el) { el.classList.toggle('on', el.dataset.plan === plan); });
    document.querySelectorAll('#product-view .mtype').forEach(function (el) { el.classList.toggle('on', el.dataset.mt === milkType); });
  }

  // Product gallery.
  var mainImage = byId('gmain');
  document.querySelectorAll('#gthumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) { mainImage.src = thumb.src; mainImage.alt = thumb.alt; }
      document.querySelectorAll('#gthumbs img').forEach(function (x) { x.classList.remove('on'); });
      thumb.classList.add('on');
    });
  });

  // Cart UI is owned by the GoKwik app embed. This file intentionally does not
  // create a second cart drawer/modal. Add the chosen variant through Shopify AJAX,
  // then emit common refresh events for theme/app listeners.
  function showAddError(message) {
    var note = byId('add-cart-note');
    if (note) note.textContent = message || 'आइटम कार्ट में नहीं जुड़ सका। कृपया फिर कोशिश करें।';
    else window.alert(message || 'आइटम कार्ट में नहीं जुड़ सका। कृपया फिर कोशिश करें।');
  }

  window.buy = function (btn) {
    if (busy) return;
    var v = VARIANTS[plan];
    busy = true;
    if (btn) { btn.disabled = true; btn.textContent = 'कार्ट में जोड़ रहे हैं…'; }
    var payload = { items: [{ id: Number(v[milkType]), quantity: v.qty }] };
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'कार्ट में जोड़ना असफल रहा।');
        return data;
      });
    }).then(function () {
      track('AddToCart', {content_name:'Humpy A2 देसी गाय का दूध ' + v.name, content_ids:[v[milkType]], content_type:'product', value:v.value, currency:'INR'});
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
      // Some theme integrations listen for Shopify's standard cart update event.
      document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function (err) {
      showAddError(err.message);
    }).finally(function () {
      busy = false;
      if (btn) { btn.disabled = false; btn.textContent = 'कार्ट में जोड़ें 👉'; }
    });
  };

  // Sticky CTA visibility.
  var sticky = byId('sticky');
  if (sticky) {
    function checkSticky() {
      if (window.scrollY > window.innerHeight) sticky.classList.add('on');
      else sticky.classList.remove('on');
    }
    window.addEventListener('scroll', checkSticky, {passive:true});
    checkSticky();
  }

  // Start view based on URL so /pages/morning-milk works after a refresh too.
  var initialProduct = location.pathname.replace(/\/+$/, '') === PRODUCT_PATH;
  showView(initialProduct ? 'product' : 'landing', false);
  // Do not add an extra PageView on each transition; the existing pixel gets ViewContent events.
})();
